<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'claimed.page.title'" [showBalance]="false" [showBanner]="false"></fgb-page-header>

<div class="container wallet-background">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="d-none d-lg-block py-3">
      <div class="rewards-back-button bg-glass-dark cursor-pointer" [routerLink]="['/rewards/wallet']">
        <span class="material-icons align-middle text-white">arrow_back_ios_new</span>
      </div>
    </div>
  </ng-container>
  <!-- Offer history -->
  <fgb-campaigns-v2-used-offers-list></fgb-campaigns-v2-used-offers-list>

  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <h5 class="m-0 text-white wallet-redeemed-title text-capitalize mb-3">{{ 'wallet.redeemed.title' | translate }}</h5>
      <fgbcl-rewards-wallet-redeemed-list
        [pageSize]="0"
        [redeemedItems]="walletItems.walletItemsClaimed"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="">
    <div class="border border-grey bg-secondary rounded">
      <div class="fw-bold font-size-12 text-center text-white py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
